import { inject, provideAppInitializer } from '@angular/core';
import { FeatureCashRegisterService } from '@h5s/feature-cash-register';

export const zBridgeVersionInitializerProvider = provideAppInitializer(() => {
  const featureCashRegisterService = inject(FeatureCashRegisterService);
  // Avviato in background, senza await: il caricamento della versione di ZBridge
  // non deve bloccare il bootstrap dell'app se il bridge non è installato o non risponde.
  featureCashRegisterService.loadZPrinterVersion();
});
